import { EventEmitter2 } from 'eventemitter2';

export enum NetworkStatus {
  Offline = 'offline',
  Online = 'online',
  Unknown = 'unknown',
}

export type NetworkDetectorState = {
  isConfirmedOffline: boolean;
  status: NetworkStatus;
};

export interface NetworkDetector extends EventEmitter2 {
  isConfirmedOffline: boolean;
  status: NetworkStatus;
}
